!function(){
  "use strict";
  const t="[data-slider-logos]", s="[data-slider-text]", e=".logos__static-row .logos__slide, [data-slider-logos] .logos__slide", i="is-selected";
  
  customElements.get("logos-component") || customElements.define("logos-component", class extends HTMLElement {
    constructor(){
      super();
      this.slideshowNav = this.querySelector(t);
      this.slideshowText = this.querySelector(s);
      this.flkty = null;
      this.logoSlides = this.slideshowNav ? this.slideshowNav.querySelectorAll(e) : [];
    }
    
    connectedCallback(){
      this.initTextSlider();
      this.initManualClicks();
    }
    
    initTextSlider(){
      if(this.slideshowText){
        // Initialize Flickity Fade on the text block to run the autoplay timeline
        this.flkty = new window.theme.FlickityFade(this.slideshowText, {
          fade: !0,
          autoPlay: 4000, // Slides text and switches dark logo highlight every 4 seconds
          prevNextButtons: !1,
          cellAlign: "center",
          contain: !0,
          pageDots: !1,
          wrapAround: !0,
          draggable: !0,
          accessibility: !1
        });

        // Listen for the text slide transition, then turn the corresponding logo black
        this.flkty.on("change", (index => {
          this.activateLogoHighlight(index);
        }));
        
        // Match initial slide state on load
        this.activateLogoHighlight(0);
      }
    }
    
    initManualClicks(){
      if(this.logoSlides.length){
        this.logoSlides.forEach((logo, index) => {
          logo.addEventListener("click", () => {
            if(this.flkty) {
              this.flkty.select(index); // Jump directly to that text quote
              this.flkty.playPlayer();  // Keep autoplay timing smooth
            } else {
              this.activateLogoHighlight(index);
            }
          });
        });
      }
    }

    activateLogoHighlight(activeIndex) {
      if(!this.logoSlides.length) return;
      this.logoSlides.forEach((logo, idx) => {
        if(idx === activeIndex) {
          logo.classList.add(i);
          logo.style.opacity = "1"; // Fully dark/visible black logo
        } else {
          logo.classList.remove(i);
          logo.style.opacity = "0.35"; // Muted gray/inactive logo
        }
      });
    }
  });
}();